// extracted by mini-css-extract-plugin
export default {"footer":"footer__0375U","copyright":"copyright__68l8q","nav":"nav__sJ67T"};